module.exports = __webpack_public_path__ + "img/pagoefectivo.3df932a9.png";